import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import {
  DictionaryField,
  DictionaryFieldFromApi,
  FieldId,
} from '../../gk-dynamic-list/services/dictionary/dictionary.model';

@Injectable({
  providedIn: 'root',
})
export class StreetGusDictionaryService {
  private dictionary: Record<FieldId, Observable<DictionaryField[]>> = {};
  constructor(private httpClient: HttpClient) {}

  get(placeId: FieldId): Observable<DictionaryField[]> {
    if (!this.dictionary[placeId]) {
      this.dictionary[placeId] = this.httpClient
        .get<
          DictionaryFieldFromApi[]
        >(`/api/emuia/gus/slo/miejsc/${placeId}/ulice`)
        .pipe(
          map((data) =>
            data.map((fieldFromApi) =>
              DictionaryField.fromApiToApp(fieldFromApi),
            ),
          ),
          shareReplay(1),
        );
    }

    return this.dictionary[placeId];
  }
}
